import { PrivateVideoDto, VideoDto } from '@app/data/dtos/multimedia/video/video.dto';
import { VideoProviderTypes } from '@app/entities/enums/media-player/media-player.enum';
import { PrivateVideo, VideoPublication } from '@app/entities/models/multimedia/video.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapVideoPublication: MapFromFn<VideoDto, VideoPublication> = (value) =>
  Builder.forModel(VideoPublication)
    .idVideo(value.id_video)
    .statusUpload(value.status_upload)
    .vimeoStatus(value.vimeo_status)
    .videoImage(value.video_image)
    .subtitles(value.subtitles)
    .thumbnail(value.thumbnail)
    .url(value.url)
    .videoProvider(value.video_provider || VideoProviderTypes.VIMEO)
    .build();

export const mapPrivateVideo: MapFromFn<PrivateVideoDto, PrivateVideo> = (value) =>
  Builder.forModel(PrivateVideo)
    .idVideo(value.id)
    .videoProvider(value.video_provider)
    .videoImage(value.video_image)
    .url(value.url)
    .title(value.title)
    .title(value.title)
    .videos(value.videos)
    .build();
